// Version utility for cache busting
export const APP_VERSION = `1.0.${Date.now()}`
export const BUILD_TIMESTAMP = new Date().toISOString() 